// extracted by mini-css-extract-plugin
export default {"subscribeButton":"SubscribeForm_subscribeButton__1q9fz","subscribeSpinner":"SubscribeForm_subscribeSpinner__3ybvk","animationTitle":"SubscribeForm_animationTitle__2Z4gh"};